async function tryLoad(url: string): Promise<Record<string, unknown> | null> {
  try {
    const response = await fetch(url, {cache: "no-store"});
    if (!response.ok) return null;
    return (await response.json()) as Record<string, unknown>;
  } catch {
    return null;
  }
}

const CONFIG_PATH = "/assets/aws-exports.json";

/** Fallback path when CDK deploys with full key (tenant-management/latest/aws-exports.json) under assets/. */
const CONFIG_FALLBACK_PATH = "/assets/tenant-management/latest/aws-exports.json";

export async function loadAmplifyConfig(): Promise<Record<string, unknown> | null> {
  for (const url of [CONFIG_PATH, CONFIG_FALLBACK_PATH]) {
    const cfg = await tryLoad(url);
    if (cfg && Object.keys(cfg).length > 0) return cfg;
  }
  return null;
}
